import {
  all,
  fork,
  takeEvery,
  call,
  put,
  select,
  takeLatest,
} from 'redux-saga/effects';
import api from '@api/api';
import * as actions from '@store/actions/pdfViewerAction';
import { push } from 'connected-react-router';
import { getApiErrorMessage } from '@common/utils';
import { SHOW_EXCEPTION_MODAL, SHOW_MODAL } from '@store/actions/commonAction';

/**
 * 재정안정계획서 문서발행 체크
 */
function* planFinancialPDF({ payload }) {
  try {
    const response = yield call(api.planFinancialPDF, {
      pathParams: {
        planEstablishNo: payload.planEstablishNo,
        applicationNo: payload.applicationNo,
        fileType: payload.fileType,
      },
    });
    const { status, data } = response;

    if (status === 200) {
      yield put({ type: actions.PLAN_FINANCIAL_PDF_SUCCESS, payload: data });
      if (payload.callback)
        payload.callback({
          type: true,
          data: {
            ...data,
            applicationNo: payload.applicationNo,
            planEstablishNo: payload.planEstablishNo,
            fileType: payload.fileType,
            rePublishYn: payload.rePublishYn,
          },
          payload,
        });
    } else {
      const errorMessage = getApiErrorMessage(response);
      yield put({
        type: SHOW_MODAL,
        payload: {
          visible: true,
          type: 'info',
          msg: errorMessage,
        },
      });

      // payload.callback(false, data?.detail, data);
    }
  } catch (error) {
    console.log('### saga error => ', error);
    yield put({ type: SHOW_EXCEPTION_MODAL, payload: error });
  }
}

function* openPDFViewer() {
  yield put(push('/pdfviewer'));
}

// 재정안정계획서 일련번호로 고객명 검색
function* searchFinancialCustomer() {
  const { financialPDFInfo } = yield select(state => state.pdfViewerReducer);
  const response = yield call(api.searchFinancialCustomer, {
    params: {
      planEstablishNo: financialPDFInfo.planEstablishNo,
      targetType: 'OWNER',
    },
  });
  const { status, data } = response;
  if (status === 200) {
    yield put({
      type: actions.SEARCH_FINANCIAL_CUSTOMER_SUCCESS,
      payload: data,
    });
  } else {
    const errorMessage = getApiErrorMessage(response);

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: errorMessage,
      },
    });
  }
}

// 재정안정계획서 전송
function* sendFinancialPdf({ payload }) {
  const { planShare } = yield select(state => state.pdfViewerReducer);
  const defaultFailMsg =
    '가입제안서 발송이 실패되었습니다.  연락처 또는 이메일 확인바랍니다.';

  try {
    const { status, data } = yield call(api.sendFinancialPdf, {
      params: planShare,
      payload: payload?.contactInfo,
    });

    const getCallbackMsg = (status, data, planShare) => {
      if (status === 200) {
        // return `고객님의 변액보험적합성 진단정보가 정상적으로 반영되었습니다.\n작성하신 변액보험 적합성 진단 및 결과지는 ${
        //   planShare.shareType === 'SMS' ? '알림톡(SMS)' : '메일'
        // }을 통하여 전달해 드리고 있습니다.`;
        return `가입제안서가 정상 발송되었습니다.`; // SAT-2962 문구 수정
      } else if (status === 404) {
        return data?.detail ?? defaultFailMsg;
      } else {
        return defaultFailMsg;
      }
    };

    payload.callback(
      [200, 404].includes(status),
      getCallbackMsg(status, data, planShare),
    );
  } catch (error) {
    console.log('### saga error => ', error);
    payload.callback(false, defaultFailMsg);
  }

  // let msg;
  // if (status === 200) {
  //   msg = '성공적으로 발송했습니다.';
  //   payload.callback(true, msg);
  // } else if (status === 404) {
  //   msg = data.detail;
  //   payload.callback(true, msg);
  // } else {
  //   payload.callback(false, '');
  // }
}

// 가입제안서 목차 조회
function* searchPlanBookmark({ payload }) {
  const { planEstablishNo, fileType } = payload;
  const response = yield call(api.searchPlanBookmark, {
    params: {
      planEstablishNo: planEstablishNo,
      fileType: fileType,
    },
  });
  const { status, data } = response;
  if (status === 200) {
    yield put({
      type: actions.SEARCH_FINANCIAL_BOOKMARK_SUCCESS,
      payload: data,
    });
  } else {
    const errorMessage = getApiErrorMessage(response);

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: errorMessage,
      },
    });

    yield put({
      type: actions.SEARCH_FINANCIAL_BOOKMARK_SUCCESS,
      payload: [],
    });
  }
}

// 청약접수된 설계 확인
function* searchPlanComplete({ payload }) {
  const response = yield call(api.planDetail, {
    params: { planEstablishNo: payload.planEstablishNo },
  });
  const { status, data } = response;
  if (status === 200) {
    if (payload.callback)
      payload.callback({
        type: true,
        data: data,
      });
  } else {
    const errorMessage = getApiErrorMessage(response);

    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg: errorMessage,
      },
    });
  }
}

// 시뮬레이션 예시표 전송
function* sendSimulationPdf({ payload }) {
  const { url, custNo, shareType } = payload;
  try {
    const { status, data } = yield call(api.sendSimulationPdf, {
      payload: { url, custNo, shareType }, //URL, 고객번호, 타입
    });
    yield put({
      type: SHOW_MODAL,
      payload: {
        visible: true,
        type: 'info',
        msg:
          status === 200
            ? `시뮬레이션 예시표가 정상 발송되었습니다.`
            : data?.detail ??
              '시뮬레이션 예시표 발송이 실패되었습니다. 연락처 확인바랍니다.',
      },
    });
  } catch (error) {
    yield put({ type: SHOW_EXCEPTION_MODAL, payload: error });
  }
}

function* watchPDFViewer() {
  yield takeEvery(actions.PLAN_FINANCIAL_PDF, planFinancialPDF);
  yield takeEvery(actions.OPEN_PDF_VIEWER, openPDFViewer);
  // 재정안정계획서 일련번호로 고객정보 조회
  yield takeLatest(actions.SEARCH_FINANCIAL_CUSTOMER, searchFinancialCustomer);
  // 재정안정계획서 전송
  yield takeLatest(actions.SEND_FINANCIAL_PDF, sendFinancialPdf);
  // 가입제안서 목차 조회
  yield takeLatest(actions.SEARCH_FINANCIAL_BOOKMARK, searchPlanBookmark);
  yield takeLatest(actions.SEARCH_PLAN_COMPLETE, searchPlanComplete);
  yield takeLatest(actions.SEND_SIMULATION_PDF, sendSimulationPdf);
}

export default function* pdfViewerSaga() {
  yield all([fork(watchPDFViewer)]);
}
